import script from "./editProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./editProfile.vue?vue&type=script&setup=true&lang=js"

import "./editProfile.vue?vue&type=style&index=0&id=3c379a7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c379a7c"]])

export default __exports__